import { Typography } from "@mui/material";
import { formatToCurrency } from "src/utils/genericFunctions";
import stringToNumber from "src/utils/stringToNumber";
const CurrencyData = ({ value }: { value: any }) => {
  return (
    <Typography
      variant="subtitle2"
      color="grey.900"
      fontWeight={"normal"}
      sx={{ textTransform: "none", color: "grey.900" }}
    >
      {formatToCurrency(stringToNumber(value))}
    </Typography>
  );
};
export default CurrencyData;
